// item_cards_main_slider

jQuery(document).ready(function () {
  jQuery(".mod-item-cards-block").each(function (index) {
    let slider = jQuery(this).find(
      ".artcile_card_list .item_cards_main_slider"
    );
    let slider2 = jQuery(this).find(
      ".case-study-listing.item_cards_main_slider"
    );

    if (jQuery(slider).find('.artcile_card_list_item').length < 4) {
      var sliderdots = false;
    } else {
      var sliderdots = true;
    }
    jQuery(slider).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: sliderdots,
      infinite: false,
      autoplay: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            dots: true,
          },
        },
      ],
    });
    jQuery(slider2).slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      autoplay: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
          },
        },
      ],
    });
  });
  offsetLeft();
});


function offsetLeft() {
  if (jQuery(window).width() > 992) {
    if ((jQuery('.artcile_card_list .item_cards_main_slider .slick-list').length > 0)) {
      var boxesoffset = jQuery('.artcile_card_list .item_cards_main_slider .slick-list').offset(),
        boxeswindWidth = jQuery(window).width();
      jQuery('.artcile_card_list .item_cards_main_slider .slick-list').css('width', (boxeswindWidth - boxesoffset.left));
    }
  }
}

jQuery(window).resize(function (jQuery) {
  offsetLeft();
});

jQuery(window).load(function () {
  offsetLeft();
});